import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import { DefaultLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const Errors = lazy(() => import("./Errors"));
const NotFound = lazy(() => import("./NotFound"));

export function getErrorRoutes() {
  return [
    { path: "/errors", layout: DefaultLayout, element: withSuspense(Errors) },
    { path: "/404", layout: DefaultLayout, element: withSuspense(NotFound) },
  ];
}

export function getDefaultRedirectRoute() {
  return { path: "/", layout: DefaultLayout, element: <Navigate to="/view-projects-superadmin" replace /> };
}

export function getNotFoundRoute() {
  return { path: "*", layout: DefaultLayout, element: withSuspense(NotFound) };
}
